module.exports = __webpack_public_path__ + "img/img1.2df7b282.jpg";